import { connect } from 'react-redux';
import MLPModule from './MLPModule';

const mapStateToProps = ({
  content: {
    mlpsImages
  }
}) => ({
  mlpsImages
});

export default connect(mapStateToProps)(MLPModule);
